import { Fragment } from 'react';
import { UMR } from '../../urbanmap/_components';
import { labelOf } from './engine';
import { objectiveLabel, priorityLabel } from './model';
import type { AnySet } from './types';

const boiler: Record<string, string> = { existantes: 'Existantes', creees: 'Créées', mixte: 'Existantes + créées' };

function rowsOf(s: AnySet): [string, string][] {
  switch (s.kind) {
    case 'demande':
      return [['Coefficient de consommation', `${s.consoCoef} %`], ['Taux de raccordement', `${s.connectionRate} %`], ['Érosion', `${s.erosion} %/an`]];
    case 'trace':
      return [['Routes interdites', `${s.forbiddenRoads}`], ['Routes obligatoires', `${s.mandatoryRoads}`], ['Routes pondérées', `${s.weightedRoads}`], ['Réseau existant', s.useExistingNetwork ? 'Réutilisé' : 'Réseau neuf']];
    case 'developpement':
      return [['Objectif prioritaire', objectiveLabel(s.objective)], ['Objectif réseau', `${s.targetKm} km`], ['Objectif énergie', `${s.targetMWh.toLocaleString('fr-FR')} MWh`], ['Autres objectifs', s.otherObjective || '—']];
    case 'phasage':
      return [['Réseau / an', `${s.kmPerYear} km/an`], ['Énergie / an', `${s.mwhPerYear.toLocaleString('fr-FR')} MWh/an`], ['Clients / an', `${s.clientsPerYear}`]];
    case 'importance':
      return [['Critère prioritaire', priorityLabel(s.priority)], ['Densification', s.densification], ['Bâtiments obligatoires', s.mandatoryBuildings.length ? s.mandatoryBuildings.map(labelOf).join(' · ') : 'Aucun'],
        ['Bâtiments déclencheurs · V2', 'Hypothèse : bâtiment + année de raccordement ; optimisation désactivée, non utilisée en V1.']];
    case 'pointsDepart':
      return [['Points de départ réseau', `${s.startPoints}`], ['Chaufferies', boiler[s.boilerRooms]], ['Mise en service', `${s.commissioningYear}`], ['Capacité', `${s.capacityMW} MW`], ['Appoint', `${s.backupYear}`], ['Capacité d’appoint', `${s.backupCapacityMW} MW`]];
  }
}

/** Résumé lecture seule d'un jeu (mode « Consulter »). */
export function SetSummary({ set }: { set: AnySet }) {
  return (
    <dl style={{ margin: 0, display: 'grid', gridTemplateColumns: '170px 1fr', gap: '8px 16px', fontSize: 14 }}>
      {rowsOf(set).map(([k, v]) => (
        <Fragment key={k}>
          <dt style={{ color: UMR.textSecondary }}>{k}</dt>
          <dd style={{ margin: 0 }}>{v}</dd>
        </Fragment>
      ))}
    </dl>
  );
}
